// Property Event Names
export const PROPERTY_EVENTS = {
  DELETE: 'property_delete',
} as const;

// Property Event Types
export interface PropertyDeleteProperties {
  user_id: string;
  property_id: string;
  status: 'started' | 'completed' | 'error';
  duration?: number; // only for completed status
  error_message?: string; // only for error status
}
